import { Helmet } from 'react-helmet';
import seoMetaData from '../../../Include/Seo/seoMetaData';
import Navbar from '../../../Include/Navbar/Navbar';
import Footer from '../../../Include/Footer/Footer';
import Breadcrumb from '../../../Pages/Services/MobileApp/Breadcum';
import breadcrumbData from '../../../Pages/Services/Data/breadcrumbData';
import whyusData from '../../../Pages/Services/Data/whyusData';
import aboutData from '../../../Pages/Services/Data/aboutData';
import contactData from '../../../Pages/Services/Data/contactData';
import faqData from '../../../Pages/Services/Data/faqData';
import '../../../../assets/css/services.css'; // Importing the CSS file for this component
import About from '../../../Pages/Services/MobileApp/About';
import Whyus from '../../../Pages/Services/MobileApp/Whyus';
import Contact from '../../../Pages/Services/MobileApp/Contact';
import Faq from '../../../Pages/Services/MobileApp/Faq';
import Contactus from '../../Home/Contact';

export default function Index() {
  const { title, description, keywords } = seoMetaData.mobileApp;
  return (
    <>
     <Helmet>
      
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta name="keywords" content={keywords} />
        <link rel="canonical" href="https://www.cloudkode.com/services/mobile-app-development" />
        <script type="application/ld+json">
          {`
          {
            "@context": "https://schema.org",
            "@type": "FAQPage",
            "mainEntity": [{
              "@type": "Question",
              "name": "What is the typical timeline for mobile app development?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "The timeline can vary based on the complexity of the app, but generally, it takes 3-6 months for a standard mobile app development project."
              }
            },{
              "@type": "Question",
              "name": "What platforms do you develop for?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "We develop for both iOS and Android platforms, ensuring your app reaches the widest audience possible."
              }
            },{
              "@type": "Question",
              "name": "Can you help with app maintenance and updates?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Yes, we offer ongoing maintenance and support services to keep your app running smoothly and up-to-date with the latest features."
              }
            },{
              "@type": "Question",
              "name": "Do you provide post-launch support?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Absolutely! We provide post-launch support to address any issues and ensure your app continues to perform well."
              }
            }]
          }
          `}
        </script>
      </Helmet>
   <Navbar />
   <Breadcrumb data={breadcrumbData.mobileapp} /> 
   <About data={aboutData.mobileapp} />
   <Whyus data={whyusData.mobileapp}/>
   <Contact data={contactData.mobileapp}/>
   <Faq data={faqData.mobileapp}/>
   <Contactus/>
   <Footer/>
   </>
  )
}
